import React, { useMemo } from 'react';
import Currency from 'react-currency-formatter';
import { useTranslation } from 'react-i18next';

// material-ui
import { TableCell, TableRow } from '@mui/material';
import useImage from 'services/Hooks/useImage';
import { useLanguageReference } from 'services/Hooks/useLanguageReference';
import { arrayUnique } from 'services/Utilities/Utilities';
import { ProjectInventoryItemAdjustmentTypeEnumValue } from 'enums/ProjectInventoryItemAdjustmentTypeEnum';

// Icons

// Styles

// Actions

// Components

// Others

const DealerCopyAdjustmentGroupedMerchandisingToolingSection = ({
  categoryLabel,
  projectInventoryItems,
  headerColSpan,
  projectAdjustments = [],
  currencyName,
}) => {
  const { t } = useTranslation();
  const { getInventoryItemImage } = useImage();
  const { descriptionReference } = useLanguageReference();

  const groupedProjectInventoryItems = useMemo(() => {
    return projectInventoryItems?.reduce((acc, cur) => {
      let lastItem = { ...acc.at(-1) };
      if (lastItem !== undefined && lastItem.inventoryItem_Id === cur.inventoryItem_Id) {
        lastItem.quantity += cur.quantity;
        lastItem.projectDealerTotalPrice += cur.projectDealerTotalPrice;
        acc = acc.with(-1, lastItem);
      } else acc.push(cur);
      return acc;
    }, []);
  }, [projectInventoryItems]);

  const uniqueInventoryItemSkus = useMemo(() => arrayUnique(projectAdjustments.map(pa => pa.inventoryItem_Id)), [
    projectAdjustments,
  ]);

  return (
    <>
      <TableRow>
        <TableCell colSpan={headerColSpan} style={{ backgroundColor: '#c9c7c7' }}>
          <strong>{categoryLabel}</strong>
        </TableCell>
      </TableRow>

      {uniqueInventoryItemSkus.map(inventoryItemId => {
        const projectInventoryItem = groupedProjectInventoryItems.find(pi => pi.inventoryItem_Id === inventoryItemId);

        const associatedProjectAjustements = projectAdjustments.filter(pa => pa.inventoryItem_Id === inventoryItemId);

        const firstProjectAjustement = associatedProjectAjustements[0];

        const totalQuantity = associatedProjectAjustements.reduce((acc, cur) => acc + (cur.quantity || 0), 0);

        return (
          <TableRow
            key={projectInventoryItem?.id || firstProjectAjustement?.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell colSpan={2}>
              {projectInventoryItem?.files?.length > 0 && (
                <img
                  src={getInventoryItemImage(projectInventoryItem?.inventoryItem_Id, projectInventoryItem?.files[0].id)}
                  alt={t('InventoryItemImage')}
                  style={{
                    maxHeight: '50px',
                    width: '100%',
                    objectFit: 'contain',
                  }}
                />
              )}
            </TableCell>
            <TableCell>
              <strong>{`${projectInventoryItem?.sku}`}</strong>
            </TableCell>
            <TableCell colSpan={2}>{projectInventoryItem?.[descriptionReference]}</TableCell>
            {firstProjectAjustement ? (
              <TableCell align="center">
                {(firstProjectAjustement.adjustmentType === ProjectInventoryItemAdjustmentTypeEnumValue.DealerInventory
                  ? Math.abs(totalQuantity)
                  : totalQuantity) || '0'}
              </TableCell>
            ) : (
              <TableCell>-</TableCell>
            )}
            <TableCell align="right">
              {projectInventoryItem?.projectDealerUnitPrice === 0 ? (
                '-'
              ) : (
                <Currency quantity={projectInventoryItem?.projectDealerUnitPrice} currency={currencyName} />
              )}
            </TableCell>
            <TableCell align="right">
              <Currency quantity={totalQuantity * projectInventoryItem?.projectDealerUnitPrice} currency={currencyName} />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default DealerCopyAdjustmentGroupedMerchandisingToolingSection;
